export const interes = [
    {
        "nombre": "Programa Anual de Mejora Regulatoria (PAMR) 2025", 
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/interes/PAMR.pdf",
        "opcion" :"2",
        "ico":"icon-continuous-improvement"
    },
    {
        "nombre": "Programa Anual de Desarrollo Archivístico (PADA) 2026",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/PADA-2026.pdf",
        "opcion" :"2",
        "ico":"icon-boxes"
    },
    {
        "nombre": "Informe Anual de Cumplimiento del Programa Anual de Desarrollo Archivístico (PADA) 2025",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/InformePADA-2025.pdf",
        "opcion" :"2",
        "ico":"icon-speaker"
    },
    {
        "nombre": "Programa Anual de Adquisiciones, Arrendamientos de Bienes Muebles y Servicios (PAAAS)",
        "url" : "../Paaas",
        "opcion" : "1",
        "ico":"icon-three-icons"
    },
    {
        "nombre": "Indicadores Sectoriales",
        "url" : "https://s-infraestructura.hidalgo.gob.mx/digital_files/Indicadores/Indicadores_sectoriales.pdf",
        "opcion" :"2",
        "ico":"icon-indicator"
    },
    {
        "nombre": "Reglamento Interior de la Secretaría de Infraestructura Pública y Desarrollo Urbano Sostenible",
        "url" : "/ReglamentoInterior",
        "opcion" :"1",
        "ico":"icon-normativity"
    },
    {
        "nombre": "Programa Sectorial de Desarrollo de Infraestructura Pública y Desarrollo Urbano Sostenible 2023 - 2028",
        "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/sectoriales.pdf",
        "opcion" :"2",
        "ico":"icon-buildings"
    },
    {
        "nombre": "Organismos Descentralizados",
        "url" : "/Organismos",
        "opcion" : "1",
        "ico":"icon-dependence"
    }, 
    {   
        "nombre": "Residencias Regionales",
        "url" : "/Residencias",
        "opcion" : "1",
        "ico":"icon-residences"
    },
    {
        "nombre": "Atlas Carretero del Estado de Hidalgo",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/interes/atlas.pdf",
        "opcion" :"2",
        "ico": "icon-atlas"
    },
    {
        "nombre": "Reconstruccion2025 y Acciones del Fondo de Aportaciones para la Infraestructura Social",
        "url" : "https://innovacion-sopot.hidalgo.gob.mx/view/public/?controller=sopot_works&view=works_fais_goals",
        "opcion" :"2",
        "ico": "icon-excavator"
    },
    {
        "nombre": "Localización geográfica de obras y/o acciones",
        "url" : "https://innovacion-sopot.hidalgo.gob.mx/view/public/?controller=sopot_works&view=works_georeference",
        "opcion" :"2",
        "ico":"icon-location"
    },
    {
        "nombre": "Protocolo Cero",
        "url" : "/ProtocoloCero",
        "opcion" : "1",
        "ico":"icon-stop"
    },
    {
        "nombre": "Comité de Ética y Prevención de Conflictos de Interés",
        "url" : "/ComiteEtica",
        "opcion" :"1",
        "ico":"icon-committee-2"
    },
    {
        "nombre": "Padrón de Beneficiarios del Programa Construye Tu Camino",
        "url" : "/PadronCTC",
        "opcion" :"1",
        "ico":"icon-beneficiarys"
    },
    {
        "nombre": "Construye Tu Camino 2026",
        "url" : "/ConstruyeTuCamino",
        "opcion" : "1",
        "ico":"icon-road-construction"
    },
    {
        "nombre": "Reconstrucción Vaguada Monzónica",
        "url" : "/Reconstruccion2025",
        "opcion" : "1",
        "ico":"icon-crane"
    },
]